// extracted by mini-css-extract-plugin
export default {"zr-main-container":"App_zr-main-container__MKfoF","zr-main-content":"App_zr-main-content__E9-ic","zr-fullscreen":"App_zr-fullscreen__cDufP"};